var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axiosInstance from '../AxiosSingleton';
export class ConfigService {
    static getInstance() {
        if (!ConfigService.instance) {
            ConfigService.instance = new ConfigService();
        }
        return ConfigService.instance;
    }
    /**
     * Chargement de la configuration du site
     * @return Configuration du site
     */
    static getConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: ConfigService.rubModule,
                    action: 'GET_CONFIG',
                },
            });
            return content;
        });
    }
}
ConfigService.rubModule = 'config';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxhQUFhLE1BQU0sbUJBQW1CLENBQUM7QUFHOUMsTUFBTSxPQUFPLGFBQWE7SUFLbEIsTUFBTSxDQUFDLFdBQVc7UUFDeEIsSUFBSSxDQUFDLGFBQWEsQ0FBQyxRQUFRLEVBQUU7WUFDNUIsYUFBYSxDQUFDLFFBQVEsR0FBRyxJQUFJLGFBQWEsRUFBRSxDQUFDO1NBQzdDO1FBRUQsT0FBTyxhQUFhLENBQUMsUUFBUSxDQUFDO0lBQy9CLENBQUM7SUFFRDs7O09BR0c7SUFDSSxNQUFNLENBQU8sU0FBUzs7WUFDNUIsTUFBTSxFQUNMLElBQUksRUFBRSxFQUFFLE9BQU8sRUFBRSxHQUNqQixHQUFHLE1BQU0sYUFBYSxDQUFDLEdBQUcsQ0FBQyxZQUFZLEVBQUU7Z0JBQ3pDLE1BQU0sRUFBRTtvQkFDUCxHQUFHLEVBQUUsYUFBYSxDQUFDLFNBQVM7b0JBQzVCLE1BQU0sRUFBRSxZQUFZO2lCQUNwQjthQUNELENBQUMsQ0FBQztZQUVILE9BQU8sT0FBTyxDQUFDO1FBQ2hCLENBQUM7S0FBQTs7QUF6QnVCLHVCQUFTLEdBQUcsUUFBUSxDQUFDIn0=